/* Helpers e constantes do módulo Roteirização */

export const TIPOS_OPERACAO = [
  { v: "entrega", label: "Entrega" },
  { v: "troca", label: "Troca" },
  { v: "devolucao", label: "Devolução" },
  { v: "retirada", label: "Retirada" },
  { v: "visita_tecnica", label: "Visita Técnica" },
  { v: "aditivo", label: "Aditivo" },
  { v: "multipla", label: "Múltipla" },
];

export const TIPOS_ATENDIMENTO_PARADA = [
  { v: "entrega", label: "Entrega" },
  { v: "troca", label: "Troca" },
  { v: "devolucao", label: "Devolução" },
  { v: "retirada", label: "Retirada" },
  { v: "visita_tecnica", label: "Visita técnica" },
  { v: "aditivo", label: "Aditivo" },
];

export const PRIORIDADES = [
  { v: "alta", label: "Alta", cls: "bg-red-100 text-red-800 border-red-300" },
  { v: "media", label: "Média", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  { v: "baixa", label: "Baixa", cls: "bg-zinc-100 text-zinc-700 border-zinc-300" },
];

export const STATUS_ROTA = [
  { v: "planejada", label: "Planejada", cls: "bg-blue-100 text-blue-800" },
  { v: "em_andamento", label: "Em andamento", cls: "bg-amber-100 text-amber-800" },
  { v: "concluida", label: "Concluída", cls: "bg-emerald-100 text-emerald-800" },
  { v: "cancelada", label: "Cancelada", cls: "bg-red-100 text-red-800" },
];

export const STATUS_PARADA = [
  { v: "pendente", label: "Pendente", cls: "bg-zinc-100 text-zinc-700" },
  { v: "em_rota", label: "Em rota", cls: "bg-blue-100 text-blue-800" },
  { v: "concluido", label: "Concluído", cls: "bg-emerald-100 text-emerald-800" },
  { v: "cancelado", label: "Cancelado", cls: "bg-red-100 text-red-800" },
  { v: "reagendado", label: "Reagendado", cls: "bg-amber-100 text-amber-800" },
];

// Deep links — funcionam sem API key
export const linkGoogleMaps = (endereco, cidade, uf) => {
  const partes = [endereco, cidade, uf].filter(Boolean).join(", ");
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(partes)}&travelmode=driving`;
};

export const linkWaze = (endereco, cidade, uf) => {
  const partes = [endereco, cidade, uf].filter(Boolean).join(", ");
  return `https://www.waze.com/ul?q=${encodeURIComponent(partes)}&navigate=yes`;
};

// Multi-stop Google Maps URL com paradas[]
export const linkGoogleMapsRota = (paradas) => {
  const lugares = paradas
    .map((p) => [p.endereco, p.cidade, p.uf].filter(Boolean).join(", "))
    .filter(Boolean);
  if (lugares.length < 2) {
    if (lugares.length === 1) return linkGoogleMaps(paradas[0].endereco, paradas[0].cidade, paradas[0].uf);
    return null;
  }
  const origin = lugares[0];
  const destination = lugares[lugares.length - 1];
  const waypoints = lugares.slice(1, -1).join("|");
  let url = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}&travelmode=driving`;
  if (waypoints) url += `&waypoints=${encodeURIComponent(waypoints)}`;
  return url;
};

export const badge = (val, list) => {
  const it = list.find((x) => x.v === val);
  return it ? { label: it.label, cls: it.cls } : { label: val, cls: "bg-zinc-100 text-zinc-700" };
};
